import { QueryClient } from '@tanstack/react-query';
import { CommonVariables, List, Lists } from 'apis/types';
import { GetListsQuery } from './reactQueryHooks';

const updateOrReplaceLists = <T extends { list: List } | { lists: Lists }>(
    data: T,
    old: GetListsQuery | undefined
) => {
    return {
        lists:
            'lists' in data
                ? data.lists
                : [
                      data.list,
                      ...(old?.lists.filter(
                          list => data.list.listId !== list.listId
                      ) || []),
                  ],
    };
};

export const handleSuccess = <T extends { list: List } | { lists: Lists }>(
    queryClient: QueryClient,
    data: T,
    commonVariables: CommonVariables
) => {
    if (!data) {
        return;
    }
    queryClient.setQueryData(
        ['GetLists', commonVariables],
        (old: GetListsQuery | undefined) => updateOrReplaceLists(data, old)
    );
    if ('list' in data) {
        queryClient.setQueryData(
            ['GetList', { ...commonVariables, listId: data?.list?.listId }],
            data
        );
    }
};
